// extracted by mini-css-extract-plugin
export var contents = "style-module--contents--8Qt6c";
export var detailMainVisual = "style-module--detailMainVisual--UAn5E";
export var image = "style-module--image--zkF4M";
export var main = "style-module--main--M4gaR";
export var sub = "style-module--sub--y42E4";